// | ------------------------------------------------------------------------
// | Cookie Consent - Cookie Options
// | ------------------------------------------------------------------------ 


import './cookieConsent';

var cookiePadding = function(){

    var popUp = document.querySelector(".cc-window");
    var popUpHeight = popUp.offsetHeight;

    // set --cookie-height custom property
    document.documentElement.style.setProperty("--cookie-height", popUpHeight + "px");

}

window.addEventListener("load", function(){
    window.addEventListener("scroll", cookiePadding, false);
    window.addEventListener("load", cookiePadding, false);
    window.addEventListener("resize", cookiePadding, false);
});

window.addEventListener("load", function(){

    window.cookieconsent.initialise({
        position: "bottom",   
        theme: "classic",
        
        onPopupOpen : function () {

            // prevent notice from 'floating' on mobiles/tablets
            document.querySelector(".cc-window").classList.remove("cc-floating");
            document.querySelector(".cc-window").classList.add("cc-banner");

            cookiePadding();       

        },
        onPopupClose : function () {
            document.documentElement.style.setProperty("--cookie-height", "0px");
        },                
        "content": {
            "message": "This website uses cookies to give you the best experience. By using our website you agree to our cookie policy",
            "dismiss": "Accept &amp; Close",
            "link": "Learn more",
            "href": "/cookies"
        },
        elements:{
            dismiss: '<button type="button" aria-label="Accept & Close cookie message" tabindex="0" class="cc-btn cc-dismiss">Accept &amp; Close</button>'
        }        
    })
});



